import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useRouter } from 'next/router';
import FaqOverviewBlock from '@components/FAQ/FaqOverviewBlock/FaqOverviewBlock';
import { getSiteUrl } from '@utils/config';
import { getWebpageTemplateContent } from '@services/contentfulService';
import { LandingPageStyles } from './LandingPage.styled';
import FaqPageSection from '@components/FAQ/FaqPageSection/FaqPageSection';
import PreFooterSection from '@components/Shared/PreFooterSection/PreFooterSection';
import HeroSection from '@components/Shared/HeroSection/HeroSection';

const LandingPage = ({ pageInfo }) => {
  const router = useRouter();

  return (
    <LandingPageStyles>
      <Head>
        <title>{pageInfo?.titleTag}</title>
        <meta name="description" content={pageInfo?.metaDescription} />
        <link rel="canonical" href={`${getSiteUrl(router.pathname)}`} />
        <meta
          property="og:image"
          content={
            pageInfo?.ogImage?.url ||
            getSiteUrl('/public-assets/images/clayton-logo.jpg')
          }
        />
      </Head>
      <HeroSection heroSection={pageInfo.heroSection} />
      <section className="faq-categories">
        {pageInfo?.mainContent?.map((category, i) =>
          category.faqLayout === 'Overview Page' ? (
            <FaqOverviewBlock
              key={`faq-category-${i + 1}`}
              category={category}
            />
          ) : null
        )}
      </section>
      <section className="faq-popularfaqs">
        {pageInfo?.mainContent?.map((category, i) =>
          category.faqLayout === 'Page Section' ? (
            <FaqPageSection
              key={`faq-popularfaqs-${i + 1}`}
              category={category}
            />
          ) : null
        )}
      </section>
      <section className="faq-prefooter">
        {pageInfo?.preFooterActions ? (
          <PreFooterSection preFooterActions={pageInfo.preFooterActions} />
        ) : null}
      </section>
    </LandingPageStyles>
  );
};

export default LandingPage;

const webPageKey = '1JsWibT9dXbmyBi4vBbxFQ';

export async function getServerSideProps() {
  let webPageContent;

  await Promise.all([
    getWebpageTemplateContent(webPageKey)
      .then((response) => {
        webPageContent = response;
      })
      .catch(() => {
        console.error('no content');
      }),
  ]);

  return {
    props: { pageInfo: webPageContent },
  };
}

LandingPage.propTypes = {
  pageInfo: PropTypes.object,
};
